import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AuthService } from '@brightside/core/auth';
import { CoreToastComponent } from '@brightside/core/toast';
import { ShellComponent } from '@brighthub/ui';

@Component({
  imports: [RouterModule, CoreToastComponent, ShellComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'brighthub';
  private _auth = inject(AuthService);
  private _title = inject(Title);
  isLoggedIn = computed(() => this._auth.loggedIn());

  constructor() {
    this._title.setTitle('BrightNav');
  }
}
